// extracted by mini-css-extract-plugin
module.exports = {"button__textMenu":"button_button__textMenu__2ZZ-m","button_unhighlight":"button_button_unhighlight__3te53","button__delLine":"button_button__delLine__1PsPx"};